import { JSEncrypt } from 'encryptlong'
import jsrsasign from 'jsrsasign'

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQOeL1vVExamS7ISO78kF0AqLuzXA/U7R6hB/t6IRsksVB4Bbtq' +
                        'W/yyHuw3BamEEVzOA4SiWrmPIlfcgLhbUkLyNwrVoS8jO9KzMWQKYKB0mB/peO9GiXuSCaCIZsX/zRqPYfBoYtF21usK1DomEznnX49L5p' +
                        '9Tbp0qmIztkYSAwIDAQAB'
const privateKey = 'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAJA54vW9UTFqZLshI7vyQXQCou7NcD9TtHqEH+3o' +
                        'hGySxUHgFu2pb/LIe7DcFqYQRXM4DhKJauY8iV9yAuFtSQvI3CtWhLyM70rMxZApgoHSYH+l470aJe5IJoIhmxf/NGo9h8Ghi0XbW6wrU' +
                        'OiYTOedfj0vmn1NunSqYjO2RhIDAgMBAAECgYAmTYlOFBpFEmlwHSv9VSg25CBbZWoDF3rd8sr8Bv1sTEpg5V+RfKdDhiT7YmgNcFLRd7' +
                        'idCau/O6KMG55SOhDkznz5XoqfMaxkdfCTsWBun9BVXuRXN5uGdun4nJjSCPJAohjSPcp6LvAR9ieCI+ufB3mqN8KdFCX43IUStadgGQJ' +
                        'BANlDln4+KNNpWDoQRSaf+39nozWeu//DyBMymDDB5duY6K30kRKrionWC82DwIRjvUDUq203BPssBbuJb2LlBHUCQQCp8K/bSoIR/Fks' +
                        'kocYiKgAtWQPwdVCDkfh9iRLoxqM20185z5JaQU8od46Cc9KnWr5gLL+fVgwJxO/j2XfTI2XAkAXwnNvxN50GD4kw2i8i5xWV4Aaugw3M' +
                        'TLtHohUNLAtbrBrbaZ70zSoVDcgN3tTPxEQSPGiVPT/ftX1p1b+CquNAkEAp4n9peF/+IFj3PicrchUcVZjTtGXEOeJYLFNOTCVBVdTvp' +
                        'cwJimemxcuQuPW9MXbaB3E2fbzUY3E/289TPdpAwJBALtJNTedEtByF1nIQYEdXnK2pIYrY9PRAaApJw1HmBhIPPJeU7tWNaL7H5LRT89' +
                        'q4jP7hmaKGdoXOt8e1xlCxQA='


// 实例化一个 Encrypt 对象
var encrypt = new JSEncrypt()

var ext = {
    // 加密
    en: function (enData) {
        // 传入公钥
        encrypt.setPublicKey(publicKey)
        // 加密数据
        enData = encrypt.encryptLong(enData)
        return enData
    },

    // 解密
    de: function (deData) {

    },

    // 加签
    si: function (signData) {
        // 创建RSA实例
        var rsa = new jsrsasign.RSAKey();
        // 解析密钥
        rsa = jsrsasign.KEYUTIL.getKey('-----BEGIN PRIVATE KEY-----' + privateKey + '-----END PRIVATE KEY-----')
        // 加密编码
        let sig = new jsrsasign.KJUR.crypto.Signature({'alg': 'MD5withRSA'})
        // 初始化
        sig.init(rsa)
        // 传入代加密数据
        sig.updateString(signData)
        // 生成密文
        return jsrsasign.hextob64(sig.sign())
    }
}

export {ext}